import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "envio-form-container" }
const _hoisted_2 = ["open"]
const _hoisted_3 = { class: "dialog-content" }
const _hoisted_4 = { class: "row mt-2" }
const _hoisted_5 = { class: "col-md-3" }
const _hoisted_6 = {
  key: 0,
  class: "form-group"
}
const _hoisted_7 = { class: "form-label" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "col-md-3" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "col-md-3 form-group" }
const _hoisted_12 = { class: "input-group" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "search-icon"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "col-md-3" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-3" }
const _hoisted_21 = { class: "form-check" }
const _hoisted_22 = {
  key: 0,
  class: "col-3"
}
const _hoisted_23 = { class: "btn-group" }
const _hoisted_24 = {
  key: 1,
  class: "col-3"
}
const _hoisted_25 = { class: "row mt-4" }
const _hoisted_26 = { class: "col-12" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "bg-light p-2" }
const _hoisted_31 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_32 = ["for"]
const _hoisted_33 = ["onUpdate:modelValue", "id"]
const _hoisted_34 = { class: "form-group mt-4" }
const _hoisted_35 = { class: "form-actions" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }

import { ref, reactive, onMounted, watch, nextTick, computed } from 'vue';
  import { useEnviosStore } from '@/stores/useEnvioStore';
  import { storeToRefs } from 'pinia';
  //import axios from 'axios';
  import _ from 'lodash';
  import entitiesAPI from '@/api/entitiesAPI';
  import usersAPI from '@/api/usersAPI';
  import SearchSelect from './SearchSelect.vue';
  import type { Envio } from '@/types/envioTypes';
  import { usePedidoStore } from '@/stores/usePedidoStore';

  type SearchSelectInstance = {
    resetInput: () => void;
    // Agrega otros métodos si los necesitas
  };

  interface Operator {
    id: number | string;
    name: string;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'EnvioFormComponent',
  props: {
    show: { type: Boolean },
    envio: {}
  },
  emits: ["close", "submitted"],
  setup(__props: any, { emit: __emit }) {

  const envioStore = useEnviosStore();
  const pedidoStore = usePedidoStore();

  const showDialog = ref(false);
  const submitting = ref(false);
  const operators = ref<Operator[]>([]);

  const currentMode = ref<'envio' | 'retorno'>('envio');

  // Definir los productos según la estructura que proporcionaste
  const productosPorCategoria = ref([
    {
      nombre: 'Modems',
      productos: [
        { id: 4, nombre: 'Sim Conexa' },
        { id: 5, nombre: 'Sim Movistar' },
        { id: 2, nombre: 'Modem Altadis' },
        { id: 3, nombre: 'Modem CV' },
        { id: 6, nombre: 'Cables Jof 6 Dig' },
        { id: 7, nombre: 'Cables Jof 4 Dig' },
        { id: 8, nombre: 'Cables GM 6 Dig' },
        { id: 9, nombre: 'Cables GM 4 Dig' },
        { id: 10, nombre: 'Cables Azk' },
        { id: 11, nombre: 'Micro' },
        { id: 12, nombre: 'Cables Jof 6 Dig Antiguo' },
        { id: 13, nombre: 'Sim COM4' }
      ]
    },
    {
      nombre: 'Grupo QPay',
      productos: [
        { id: 18, nombre: 'Qpay Libre' },
        { id: 19, nombre: 'Atax' },
        { id: 20, nombre: 'MDB Atax' },
        { id: 21, nombre: 'Tornillos' },
        { id: 22, nombre: 'Arandelas' },
        { id: 23, nombre: 'Funda Qpay' },
        { id: 24, nombre: 'Pegatinas Agujero Qpay' },
        { id: 25, nombre: 'Cajas ATAX' }
      ]
    },
    {
      nombre: 'Grupo Ingénico',
      productos: [
        { id: 14, nombre: 'Ingenico Libre' },
        { id: 15, nombre: 'Raspberry' },
        { id: 16, nombre: 'MDB Raspberry' },
        { id: 17, nombre: 'Pegatina Agujero Ingénico' }
      ]
    },
    {
      nombre: 'Grupo Sueltos',
      productos: [
        { id: 26, nombre: 'Antena' },
        { id: 27, nombre: 'SIM Telenor' },
        { id: 28, nombre: 'Pegatina Instrucciones' },
        { id: 29, nombre: 'Módulo Ingénico' },
        { id: 30, nombre: 'Módulo Wifi' },
        { id: 31, nombre: 'Adaptador MDB' },
        { id: 32, nombre: 'Cable USB' }
      ]
    }
  ]);

  const formatDate = (date: string | Date | null): string | null => {
    if (!date) return null;
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handlePedidoSearch = async (pedidoId: number | null) => {
    console.log("PEDIDO ID: ", pedidoId)
    if (pedidoId) {
      const response = await pedidoStore.startSearch(pedidoId);

      formData.id_expendeduria = response.id_expendeduria

      /* expendeduriaInitialValue.value = {
        id: response.id_expendeduria,
        name: response.expendeduria_nombre
      } */

      expendeduriaInitialValue.value = response.expendeduria_nombre

      for (const key in formData.cantidades.envio) {
        formData.cantidades.envio[key] = 0
      }

      if (response) {
        for (let key in response.productos_necesarios) {
          const productId = Number(key)
          formData.cantidades.envio[productId] = response.productos_necesarios[key]
        }
      }
    }
  };

  // Computed para obtener todos los productos en un solo array (si es necesario)
  const todosLosProductos = computed(() => {
    return productosPorCategoria.value.flatMap(categoria => categoria.productos);
  });

  const expendeduriaInitialValue = ref('');
  const expendeduriaSelect = ref<SearchSelectInstance | null>(null);

  const props = __props;

  const emit = __emit;
  
  // Eliminar showDialog y usar prop
  watch(() => props.show, (newVal) => {
    if (!newVal) resetForm();
  });

  // Modificar métodos de cierre y envío
  const closeDialog = () => {
    emit('close');
  };


  // Estado del formulario
  const formData = reactive({
    id: null as number | null,
    id_expendeduria: null as number | null,
    id_operator: null as number | null,
    status: null as string | null,
    description: ''   as string | null,
    id_pedido_cv: null as number | null,
    with_return: false as boolean,
    date_return: '' as string | null,
    cantidades: {
      envio: {} as Record<number, number>, // ID - cantidad
      retorno: {} as Record<number, number>
    }
  });

  // Inicializar todas las cantidades en 0
  const inicializarCantidades = () => {
    productosPorCategoria.value.forEach(categoria => {
      categoria.productos.forEach(producto => {
        if (formData.cantidades.envio[producto.id] === undefined) {
          formData.cantidades.envio[producto.id] = 0;
        }
      });
    });
  };

  
  // Lista de operadores
  const statusOptions = ref([
    { value: 'pendiente', label: 'Pendiente' },
    { value: 'enviado', label: 'Enviado' },
    { value: 'cancelado', label: 'Cancelado' }
  ]);

  const operatorsLoaded = ref(false);
  const operatorsError = ref(false);
  const loadingOperators = ref(false);

  watch(() => props.show, async (visible) => {
    if (visible) {
      // Solo resetea si NO estamos editando un envio existente
      if (!props.envio) {
        resetForm();
      }/*  else {
        inicializarCantidades();
      } */
      
      // Cargar operadores solo si no se han cargado antes y no hay error
      if (!operatorsLoaded.value && !operatorsError.value && !loadingOperators.value) {
        await loadOperators();
      }

      if (props.envio) {
        await loadEnvioData(props.envio);
      }

      // Solo resetear los inputs si no estamos editando
      await nextTick();
      if (!props.envio) {
        expendeduriaSelect.value?.resetInput();
      }
    }
  });

  // Búsqueda de expendedurías
  const expendeduriasResults = ref<any[]>([]);
  const loadingExpendedurias = ref(false);
  const handleExpendeduriaSearch = _.debounce(async (query: string) => {
    if (query === "") {
      expendeduriasResults.value = [];
      return
    }
    
    try {
      loadingExpendedurias.value = true;
      const response = await entitiesAPI.searchExpendeduria(query);
      expendeduriasResults.value = response.results.slice(0, 10);
    } catch (error) {
      console.error('Error buscando expendedurías:', error);
    } finally {
      loadingExpendedurias.value = false;
    }
  }, 500);
  
  const selectExpendeduria = (item: any) => {
    formData.id_expendeduria = item.id;
  };
  
 
  
  // Envío del formulario
  const submitForm = async () => {
    if (!formData.id_operator) {
      alert('Por favor selecciona un operador');
      return;
    }

    if (!formData.status) {
      alert('Por favor selecciona el estado del envio')
    }

/*     // Validar que al menos un producto tenga cantidad mayor a 0
    const hasProducts = Object.values(formData.cantidades).some(cantidad => cantidad > 0);
    if (!hasProducts) {
      alert('Por favor ingresa al menos una cantidad mayor a 0 para algún producto');
      return;
    } */

    submitting.value = true;
    
    try {
      // Preparar detalles del envío
      /* const cantidades = Object.entries(formData.cantidades.envio)
      .filter(([_, cantidad]) => cantidad != 0)
      .map(([idProducto, cantidad]) => ({
        id_producto: parseInt(idProducto),
        cantidad: Number(cantidad)
      }));
       */
      const cantidades = [
        ...Object.entries(formData.cantidades.envio)
          .filter(([_, cantidad]) => cantidad !== 0)
          .map(([idProducto, cantidad]) => ({
            id_producto: parseInt(idProducto),
            cantidad: Number(cantidad),
            tipo: "envio"
          })),
        ...Object.entries(formData.cantidades.retorno)
          .filter(([_, cantidad]) => cantidad !== 0)
          .map(([idProducto, cantidad]) => ({
            id_producto: parseInt(idProducto),
            cantidad: Number(cantidad),
            tipo: "retorno"
          }))
      ];

      const payload = {
        id_operator: formData.id_operator,
        id_expendeduria: formData.id_expendeduria,
        status: formData.status,
        description: formData.description,
        id_pedido_cv: formData.id_pedido_cv,
        with_return: formData.with_return,
        date_return: formatDate(formData.date_return),
        cantidades: cantidades
      };

      console.log("PAYLOAD:")
      console.log(payload)

      // Agregar id_expendeduria solo si tiene valor
      if (formData.id_expendeduria) {
          payload.id_expendeduria = formData.id_expendeduria;
      }


      if (formData.id) {
        // modo edición
        await envioStore.updateEnvio(formData.id, payload)
      } else {
        // modo creación
        await envioStore.createEnvio(payload);
      }

      emit('submitted')
      emit('close')
      resetForm();
    } catch (error) {
      console.error('Error creando o editanto envio:', error);
      alert('Error al guardar o editar el envio');
    } finally {
      submitting.value = false;
    }
  };
  
  const resetForm = () => {
    formData.id = null;
    formData.id_expendeduria = null;
    formData.id_operator = null;
    formData.status = "enviado";
    formData.description = '';
    formData.with_return = false;
    formData.cantidades.envio = {};
    formData.cantidades.retorno = {};
    
    currentMode.value = 'envio'

    inicializarCantidades();

    expendeduriasResults.value = [];
    handleExpendeduriaSearch.cancel();
    expendeduriaInitialValue.value = "";
  };

  watch(() => formData.id_operator, (newVal) => {
    console.log('Operador seleccionado:', newVal);
  });


  watch(() => props.show, async (visible) => {
    if (visible) {
      if (!props.envio) {
        resetForm();
      }
      
      if (operators.value.length === 0) {
        await loadOperators();
      }

      if (props.envio) {
        await loadEnvioData(props.envio);
      }

      // Solo resetear los inputs si no estamos editando
      await nextTick();
      if (!props.envio) {
        expendeduriaSelect.value?.resetInput();
      }

      // Limpiar físicamente los inputs
      /* setTimeout(() => {
        const inputs = document.querySelectorAll('.search-select input');
        inputs.forEach(input => (input as HTMLInputElement).value = '');
      }, 50); */
    }
  });

  /* const loadOperators = async () => {
    try {
      const response = await usersAPI.getOperators();
      operators.value = response.results.map((operator: any) => ({
        id: Number(operator.id),
        name: operator.username || 'Sin nombre' // Manejar casos null
      }));
    } catch (error) {
      console.error('Error cargando operadores:', error);
      alert('Error al cargar operadores');
    }
  }; */

  const loadOperators = async () => {
    loadingOperators.value = true;
    try {
      const response = await usersAPI.getOperators();
      operators.value = response.results.map((operator: any) => ({
        id: Number(operator.id),
        name: operator.username || 'Sin nombre'
      }));
      operatorsLoaded.value = true;
      operatorsError.value = false;
    } catch (error) {
      console.error('Error cargando operadores:', error);
      operatorsError.value = true;
    } finally {
      loadingOperators.value = false;
    }
  };


  const loadEnvioData = async (envio: Envio) => {    
    formData.id = envio.id;
    formData.id_expendeduria = envio.id_expendeduria;
    formData.id_operator = envio.id_operator;
    formData.status = envio.status;
    formData.description = envio.description;
    formData.id_pedido_cv = envio.id_pedido_cv;
    formData.with_return = envio.with_return || false;

    inicializarCantidades();

    console.log("ESTAMOS EN INICIALIZAR CANTIDADESSSSSSSSSSSSSSSSSSSSSss")
    console.log(envio.detalles)

    // Cargar productos seleccionados y cantidades si estamos editando
    if (envio.detalles && Array.isArray(envio.detalles)) {
      envio.detalles.forEach(d => {
        formData.cantidades.envio[d.id_producto] = d.cantidad;
      });

      console.log("FORM DATAAAAAAAAAAAAAAAAaaa")
      console.log(formData.cantidades)
    }

    // Establecer valores iniciales para los campos de búsqueda
    expendeduriaInitialValue.value = envio.expendeduria_nombre || '';

    // Forzar la actualización de los componentes SearchSelect
    /* await nextTick();
    if (expendeduriaSelect.value) {
      expendeduriaSelect.value.resetInput();
    }
    if (maquinaSelect.value) {
      maquinaSelect.value.resetInput();
    } */
  }
  inicializarCantidades();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("dialog", {
      open: _ctx.show,
      class: "envio-dialog"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _withModifiers(submitForm, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (formData.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("label", _hoisted_7, "ID: " + _toDisplayString(formData.id), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label" }, "Expendeduría:", -1)),
                _createVNode(SearchSelect, {
                  "reset-trigger": !_ctx.show,
                  items: expendeduriasResults.value,
                  loading: loadingExpendedurias.value,
                  "initial-value": expendeduriaInitialValue.value,
                  "item-text": "name",
                  onSearch: _unref(handleExpendeduriaSearch),
                  onSelect: selectExpendeduria,
                  placeholder: "Buscar expendeduría...",
                  ref_key: "expendeduriaSelect",
                  ref: expendeduriaSelect
                }, null, 8, ["reset-trigger", "items", "loading", "initial-value", "onSearch"])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-label" }, "Operador:", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select form-select-sm p-1",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.id_operator) = $event))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(operators.value, (operator) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: operator.id,
                    value: operator.id
                  }, _toDisplayString(operator.name), 9, _hoisted_10))
                }), 128))
              ], 512), [
                [_vModelSelect, formData.id_operator]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { class: "form-label" }, "ID Pedido (Opcional)", -1)),
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.id_pedido_cv) = $event)),
                  type: "number",
                  maxlength: "5",
                  class: "form-control",
                  placeholder: "N° Pedido"
                }, null, 512), [
                  [_vModelText, formData.id_pedido_cv]
                ]),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (handlePedidoSearch(formData.id_pedido_cv))),
                  disabled: _unref(pedidoStore).isLoading,
                  class: "btn btn-outline-secondary",
                  type: "button"
                }, [
                  (!_unref(pedidoStore).isLoading)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_14, "🔍"))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_13),
                _createVNode(_Transition, { name: "fade" }, {
                  default: _withCtx(() => [
                    (_unref(pedidoStore).error || _unref(pedidoStore).lastResult)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["import-feedback", { 'error': _unref(pedidoStore).error, 'success': _unref(pedidoStore).lastResult }])
                        }, [
                          (_unref(pedidoStore).error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, "❌ "))
                            : (_unref(pedidoStore).lastResult)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_16, "✅"))
                              : _createCommentVNode("", true)
                        ], 2))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[13] || (_cache[13] = _createElementVNode("label", { class: "form-label" }, "Estado: ", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select form-select-sm p-1",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.status) = $event))
              }, [
                _cache[12] || (_cache[12] = _createElementVNode("option", {
                  value: "",
                  disabled: "",
                  selected: ""
                }, "Seleccione un estado", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statusOptions.value, (status) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: status.value,
                    value: status.value
                  }, _toDisplayString(status.label), 9, _hoisted_18))
                }), 128))
              ], 512), [
                [_vModelSelect, formData.status]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.with_return) = $event)),
                  id: "withReturn"
                }, null, 512), [
                  [_vModelCheckbox, formData.with_return]
                ]),
                _cache[14] || (_cache[14] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "withReturn"
                }, " Incluye retorno ", -1))
              ])
            ]),
            (formData.with_return)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(['btn', currentMode.value === 'envio' ? 'btn-dark' : 'btn-outline-dark']),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (currentMode.value = 'envio'))
                    }, " Envío ", 2),
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(['btn', currentMode.value === 'retorno' ? 'btn-dark' : 'btn-outline-dark']),
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (currentMode.value = 'retorno'))
                    }, " Retorno ", 2)
                  ])
                ]))
              : _createCommentVNode("", true),
            (formData.with_return)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-label" }, "Día de retorno:", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.date_return) = $event))
                  }, null, 512), [
                    [_vModelText, formData.date_return]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              (currentMode.value==='envio')
                ? (_openBlock(), _createElementBlock("h5", _hoisted_27, "Productos para el Envío"))
                : (_openBlock(), _createElementBlock("h5", _hoisted_28, "Productos para el Retorno")),
              _createElementVNode("div", _hoisted_29, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productosPorCategoria.value, (categoria) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "col-md-3",
                    key: categoria.nombre
                  }, [
                    _createElementVNode("h6", _hoisted_30, _toDisplayString(categoria.nombre), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoria.productos, (producto) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["producto-item", {'resaltado': formData.cantidades[currentMode.value][producto.id] > 0, 'resaltado-negativo': formData.cantidades[currentMode.value][producto.id] < 0}]),
                        key: producto.id
                      }, [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("label", {
                            class: "form-check-label mb-0 flex-grow-1",
                            for: 'cantidad-' + producto.id
                          }, _toDisplayString(producto.nombre), 9, _hoisted_32),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": ($event: any) => ((formData.cantidades[currentMode.value][producto.id]) = $event),
                            class: "form-control form-control-sm cantidad-input",
                            style: {"background-color":"transparent"},
                            id: 'cantidad-' + producto.id,
                            placeholder: "0"
                          }, null, 8, _hoisted_33), [
                            [
                              _vModelText,
                              formData.cantidades[currentMode.value][producto.id],
                              void 0,
                              { number: true }
                            ]
                          ])
                        ])
                      ], 2))
                    }), 128))
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _cache[16] || (_cache[16] = _createElementVNode("label", { class: "form-label" }, "Descripción:", -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.description) = $event)),
              rows: "4"
            }, null, 512), [
              [_vModelText, formData.description]
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("button", {
              type: "button",
              onClick: closeDialog,
              class: "cancel-btn"
            }, " Cancelar "),
            _createElementVNode("button", {
              type: "submit",
              disabled: submitting.value,
              class: "btn btn-dark"
            }, [
              (submitting.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_37, "Guardando..."))
                : (_openBlock(), _createElementBlock("span", _hoisted_38, "Guardar Envio"))
            ], 8, _hoisted_36)
          ])
        ], 32)
      ])
    ], 8, _hoisted_2)
  ]))
}
}

})